import { Box } from "@mui/material";
import { Droppable } from "react-beautiful-dnd";
import SystemChoiceDraggable from "./SystemChoiceDraggable";
import SimpleAccordin from "../../../components/SimpleAccordin";
import CoverageDroppable from "./CoverageDroppable";

const SystemChoiceDroppable = ({ systemChoices, questionCitations, b503Operations, a503Operations, coverageDndType, coverageChoice, inspection, expandedAccordions, onAccordionChange, citationsLoading }) => {
  
  const convertOperationsToQuestionCitations = (operations, operationType) => {
    return operations.map((operation, index) => {
      const uid = operationType === '503B'
        ? operation.inspection_503b_operation_uid
        : operation.inspection_503a_operation_uid;
      return {
        code: `${operationType}-${uid}`,
        detail: {
          index,
          systemChoice: `other-${operationType.toLowerCase()}`,
          coverageChoice: operation.detail?.coverageChoice || coverageChoice,
          citationLanguage: operation.description || operation.code || `${operationType} Operation`,
          citationSpecifically: operation.detail?.citationSpecifically || operation.description || operation.code || `${operationType} Operation content`,
          citationSupporting: operation.detail?.citationSupporting || "",
          citationDiscussion: operation.detail?.citationDiscussion || "",
          citationCapa: operation.detail?.citationCapa || "",
          coverageComment: operation.detail?.coverageComment || "",
          rating: operation.detail?.rating || "1",
          sortOrder: operation.detail?.sortOrder ?? index,
        },
        inspection_detail_uid: operation.inspection_detail_uid,
        ...(operationType === '503B'
          ? { inspection_503b_operation_uid: operation.inspection_503b_operation_uid }
          : { inspection_503a_operation_uid: operation.inspection_503a_operation_uid }),
        lookup_code_type: operationType,
        originalOperation: operation,
      };
    }).sort((a, b) => (a.detail.sortOrder ?? 0) - (b.detail.sortOrder ?? 0));
  };

  const filtered503BOperations = b503Operations?.filter(
    op => op.detail?.coverageChoice === coverageChoice
  ) || [];

  const filtered503AOperations = a503Operations?.filter(
    op => op.detail?.coverageChoice === coverageChoice
  ) || [];

  return (
    <Box>
      <Droppable droppableId="systemChoicesDroppableId" type="systemChoice">
        {(provided) => (
          <Box {...provided.droppableProps} ref={provided.innerRef}>
            {systemChoices?.map((systemChoice, index) => {
              return <SystemChoiceDraggable key={systemChoice?.code_table_uid}
                systemChoice={systemChoice}
                questionCitations={questionCitations}
                coverageDndType={coverageDndType}
                coverageChoice={coverageChoice}
                inspection={inspection}
                index={index}
                expanded={expandedAccordions?.[systemChoice?.code_table_uid]}
                onAccordionChange={onAccordionChange}
                citationsLoading={citationsLoading} />;
            })}
            
            {/* 503B Operations "Other" Section */}
            {filtered503BOperations.length > 0 && (
              <Box key="503b-other-section" style={{ marginTop: '16px' }}>
                <SimpleAccordin 
                  title="Other (503B)"
                  isDragNDrop={false}
                  expanded={expandedAccordions?.['503b-other']}
                  onChange={onAccordionChange('503b-other')}
                >
                  <CoverageDroppable 
                    systemChoice={{ code_table_uid: "other-503b", description: "Other (503B)", id: "503b-other" }}
                    questionCitationsPerSystemChoice={convertOperationsToQuestionCitations(filtered503BOperations, '503B')} 
                    coverageDndType={coverageDndType}
                    droppableType={`${coverageDndType}-503b`}
                    coverageChoice={coverageChoice}
                    inspection={inspection}
                  />
                </SimpleAccordin>
              </Box>
            )}

            {/* 503A Operations "Other" Section */}
            {filtered503AOperations.length > 0 && (
              <Box key="503a-other-section" style={{ marginTop: '16px' }}>
                <SimpleAccordin
                  title="Other (503A)"
                  isDragNDrop={false}
                  expanded={expandedAccordions?.['503a-other']}
                  onChange={onAccordionChange('503a-other')}
                >
                  <CoverageDroppable
                    systemChoice={{ code_table_uid: "other-503a", description: "Other (503A)", id: "503a-other" }}
                    questionCitationsPerSystemChoice={convertOperationsToQuestionCitations(filtered503AOperations, '503A')}
                    coverageDndType={coverageDndType}
                    droppableType={`${coverageDndType}-503a`}
                    coverageChoice={coverageChoice}
                    inspection={inspection}
                  />
                </SimpleAccordin>
              </Box>
            )}
            
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </Box>
  );
};

export default SystemChoiceDroppable;
